import { makeAutoObservable, runInAction } from 'mobx';
import { apiServiceV2 } from '../../services/apiService';
import { globalStore } from '../../global.store';
import { sendMessageStore } from '../../modules/unityLayout/sendMessage.store';
import { formatDate } from '../../helpers/utils';
import { unityProviderStore } from '../UnityLoader/unity.provider.store';

class ReserveTablePopupsStore {
  reserveTable = 0;

  reserveTableStatus = false;

  bookingConfirmationPopup = false;

  reservedTableData: any = null;

  guestCount = 1;

  tableStatus = 'Free';

  reserveDate: Date = new Date();

  constructor() {
    makeAutoObservable(this);
  }

  onReserve = (id: number) => {
    this.reserveTable = id;
    this.reserveTableStatus = true;
    // this.getCurrentTableInfo(id)
  };

  setGuestCount = (guestCount: number) => {
    this.guestCount = guestCount;
  };

  changeGuestCount = (name: string, value: number) => {
    this.setGuestCount(value);
  };

  changeTableStatus = (name: string, value: string) => {
    this.setTableStatus(value);
  };

  setTableStatus = (value: string) => {
    this.tableStatus = value;
  };

  setReserveTable = (id: number) => {
    this.reserveTable = id;
  };

  setReserveDate = (reserveDate: Date) => {
    this.reserveDate = reserveDate;
  };

  changeDate = (values: any[]) => {
    if (values.length) this.setReserveDate(values[0]);
  };

  getCurrentTableInfo = async (id: any) => {
    const response = await apiServiceV2.getAllTables();
    if (!response.error) {
      const tables = response.data.result.filter(
        (table: any) => table.chair_id == id,
      );
      if (tables.length) {
        this.setReserveDate(tables[0].reserved_date);
        this.setGuestCount(tables[0].people_count);
        this.setTableStatus('1');
        // this.reserveTableStatus = "1";
      } else {
        this.setGuestCount(1);
        this.setTableStatus('0');
        // this.reserveTableStatus = "0";
      }
    }
  };

  reserveCurrentTable = async (date: any) => {
    const response = await apiServiceV2.reserveTable({
      tableId: this.reserveTable,
      guestCount: this.guestCount,
      startDate: formatDate(date, 'yyyy-MM-dd HH:mm'),
    });
    if (!response.error) {
      globalStore.setToasts(true, 'its_success');
      runInAction(() => {
        unityProviderStore.roomData.reserved.push(response.data.result);
        this.reservedTableData = response.data.result;
        this.bookingConfirmationPopup = true;
      });
      sendMessageStore.sendMessage(
        'ReactManager',
        'TableReserved',
        JSON.stringify({
          id: this.reserveTable,
          is_reserved: `${true}`,
        }),
      );
    } else {
      globalStore.setToasts(true, response.message);
    }
    this.clearData();
  };

  unreserveCurrentTable = async () => {
    const response = await apiServiceV2.unreserveTable({
      chairs: [this.reserveTable],
    });
    if (!response.error) {
      sendMessageStore.sendMessage(
        'ReactManager',
        'TableReserved',
        JSON.stringify({
          id: this.reserveTable,
          is_reserved: `${false}`,
        }),
      );
      globalStore.setToasts(true, 'its_success');
    } else {
      globalStore.setToasts(true, 'something_went_wrong');
    }
    this.clearData();
  };

  updateTableStatus = async () => {
    // if(this.tableStatus === "1") {
    //     await this.reserveCurrentTable(this.reserveDate, formatDate(this.reserveDate, "HH:mm"))
    // } else {
    //     await this.unreserveCurrentTable()
    // }
    // this.clearData();
  };

  setBookingConfirmationPopup = (bool: boolean) => {
    this.bookingConfirmationPopup = bool;
  };

  clearData = () => {
    this.setReserveTable(0);
    this.setGuestCount(1);
    this.setReserveDate(new Date());
    this.reserveTableStatus = false;
    this.tableStatus = 'Free';
  };
}

export const reserveTablePopupsStore = new ReserveTablePopupsStore();
